import { Check } from 'lucide-react';
import { FieldError } from '@/components/common/FieldError';
import { RequiredAsterisk } from '@/components/common/RequiredAsterisk';
import { getFieldErrorId } from '@/lib/formErrors';
import { cn } from '@/lib/utils';

export function CheckboxChipGroup({ idPrefix, legend, required = false, options, selectedValues, onChange, error }) {
  const errorId = getFieldErrorId(idPrefix);

  function toggleOption(optionValue) {
    const isSelected = selectedValues.includes(optionValue);
    onChange(isSelected ? selectedValues.filter((selectedValue) => selectedValue !== optionValue) : [...selectedValues, optionValue]);
  }

  return (
    <fieldset aria-describedby={error ? errorId : undefined} className="space-y-3">
      <legend className="text-sm font-semibold text-graphite">
        {legend}
        {required ? <RequiredAsterisk /> : null}
      </legend>
      <div className="flex flex-wrap gap-2">
        {options.map((option) => {
          const inputId = `${idPrefix}-${option.value}`;
          const isChecked = selectedValues.includes(option.value);
          return (
            <label
              key={option.value}
              htmlFor={inputId}
              className={cn(
                'inline-flex cursor-pointer select-none items-center gap-2 rounded-full border px-4 py-2 text-sm font-medium transition-colors has-[:focus-visible]:outline-2 has-[:focus-visible]:outline-offset-2 has-[:focus-visible]:outline-graphite',
                isChecked ? 'border-graphite bg-graphite text-paper' : 'border-grid bg-paper text-graphite hover:border-graphite/40',
                error && !isChecked && 'border-redline/60'
              )}
            >
              <input
                id={inputId}
                type="checkbox"
                checked={isChecked}
                onChange={() => toggleOption(option.value)}
                className="sr-only"
              />
              {isChecked ? <Check aria-hidden="true" strokeWidth={3} className="size-4" /> : null}
              {option.label}
            </label>
          );
        })}
      </div>
      <FieldError id={errorId} message={error} />
    </fieldset>
  );
}